import * as React from "react";
import { Box, Button } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import DanfeFirstPage from "../../components/danfepdf/DanfeFirstPage";
import DanfeNextPage from "../../components/danfepdf/DanfeNextPage";
import "./DanfePdfPage.css";
import { useTranslation } from "react-i18next";

const DanfeBatchPage = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const danfes = location.state?.danfes || [];

  if (!danfes.length) {
    return <Box sx={{ p: 2 }}>{t("danfe.noneFound")}</Box>;
  }

  return (
    <Box sx={{ p: 2, backgroundColor: "background.default", minHeight: "100vh" }}>
      <Box
        className="danfe-no-print"
        sx={{ display: "flex", justifyContent: "flex-end", gap: 1, mb: 1 }}
      >
        <Button
          variant="outlined"
          onClick={() => navigate(-1)}
          sx={{ textTransform: "none" }}
        >
          {t("buttons.bClose")}
        </Button>
        <Button
          variant="contained"
          onClick={() => window.print()}
          sx={{ textTransform: "none" }}
        >
          {t("buttons.bpdf")}
        </Button>
      </Box>

      {danfes.map((data, danfeIndex) => (
        <React.Fragment key={`${data.chaveAcesso}-${danfeIndex}`}>
          <DanfeFirstPage data={data} folha={`1/${data.itemsPages.length}`} />

          {data.itemsPages.slice(1).map((items, index) => (
            <DanfeNextPage
              key={`${data.chaveAcesso}-${index}`}
              data={data}
              folha={`${index + 2}/${data.itemsPages.length}`}
              items={items}
            />
          ))}
        </React.Fragment>
      ))}
    </Box>
  );
};

export default DanfeBatchPage;